import type { FC } from 'react';
import type { SelectProps } from '@george-labs.com/design-system/types/components/Select/Select';

import { t } from '@luna/i18n';

import type { Address } from '../ContactTypes';
import type { OmittedPropsFromSelect } from './ContactSelect';
import { ContactSelect } from './ContactSelect';
import { useAddresses } from '../useAddresses';
import { convertAddressesToSelectItems, getAddNewAddressHref } from './AddressSelectService';
import { isAddressEntryAllowed } from '../AddressesService';
import { useContactListFlags } from '../useContacts';

type Props = Omit<SelectProps, OmittedPropsFromSelect> & {
    preselectPrimaryAddress?: boolean;
    backUrl?: string;
    onSelect: (addresses: Address[]) => void;
};

export const AddressSelect: FC<Props> = ({ value, preselectPrimaryAddress, backUrl, ...props }) => {
    const { flags } = useContactListFlags();
    const [{ addresses, isLoading, hasError }, fetchContacts] = useAddresses();

    return (
        <ContactSelect
            value={value}
            contacts={addresses}
            isLoading={isLoading}
            hasError={hasError}
            isNewContactAllowed={isAddressEntryAllowed(flags)}
            invalidContactText={t('contactDataManagement.selectedAddressIsNotValidWarning')}
            invalidContactBtnLabel={t('contactDataManagement.manageAddressesLink')}
            preselectPrimaryContact={preselectPrimaryAddress}
            addNewContactHref={getAddNewAddressHref(backUrl)}
            convertContactsToSelectItems={convertAddressesToSelectItems}
            fetchContacts={fetchContacts}
            {...props}
        />
    );
};
